import { apiHelper } from "@/utils";
import { API } from "@/constants";

const URL = `${API.BASE_URL_API}/v1/meeting-room-bookings`;
export const meetingRoomBookingService = { getAll, show };

export function getAll(filter = {}) {
  const params = {
    page: filter.pageNumber,
    size: filter.pageSize,
    meeting_room_uuid: filter.meetingRoomUUID || undefined,
    company_uuid: filter.companyUUID || undefined,
    office_uuid: filter.officeUUID || undefined,
    meeting_date_start: filter.meetingDateStart || undefined,
    meeting_date_end: filter.meetingDateEnd || undefined,
    is_active: filter.isActive === "" ? undefined : filter.isActive,
    sortBy: filter.sortBy,
    orderBy: filter.orderBy,
  };
  if (filter.searchArray?.length) params.search_words = filter.searchArray;
  return apiHelper(URL).get("", { params });
}

export function show(uuid) {
  return apiHelper(URL).get(`/${uuid}`);
}
